import "./CertificateTemplate.css";
import img1 from "../Images/kulogo.jpeg";
import img2 from "./acoe_signature.jpeg";
import { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import axios from "../axios.jsx";
axios.defaults.xsrfCookieName = "csrftoken";
axios.defaults.xsrfHeaderName = "X-CSRFTOKEN";

function CertificateTemplate() {
  const [certificateData, setCertificateData] = useState({});
  const loc = useLocation();
  function removeNavbar() {
    document.getElementsByClassName("navbar")[0].style.display = "none";
  }
  async function GetData() {
    try {
      var reqData = {
        mobile: loc.state.mobile,
      };
      const resData = await axios.post("api/get-certificate-details", reqData);
      if (resData.status === 200) {
        setCertificateData(resData.data.data);
      }
    }
    catch (e) {
      alert("invalid scholar id");
      window.location.href = "/status";
    }
  }

  useEffect(() => {
    if (loc.state === null) {
      alert("can't access this page");
      window.location.href = "/status";
    } else {
      GetData();
    }
    removeNavbar();
  }, []);
  const printyo = () => {
    window.print();
  };
  return (
    <>
      <div class="whole">
        <div className="top">
          <div class="first">
            <span className="first-1">
              Dr.Md.Mustafa
              <br />
              <span className="first-2">
                Professor of Botany <br />
              </span>
              <span className="first-3"> Addl.Controller of Examinations</span>
              <br />
              (Confidential)
            </span>
          </div>
          <div class="second">
            <img src={img1} height="130px" width="120px" alt="" />
          </div>
          <div className="third">
            <span className="third-1">KAKATIYA UNIVERSITY</span>
            <br />
            <span className="third-2">
              Vidyaranyapuri
              <br />
              WARANGAL-506 009(T.S)
            </span>
          </div>
        </div>
        <br />
        <div class="fourth">
          <span className="fourth-1">Accredited with 'A+' Grade by NAAC</span>
        </div>
        <div className="fifth">
          <span className="fifth-1">
            Mobile:9440582638, Off:0870-2453800, Extn.511, Fax: 0870-2438875,<br />
            E-mail:researchconfidentail@kakatiya.ac.in
          </span>
        </div>
        <div className="sixth">
          <div className="id_date">Id no: <b>{certificateData["id"]}</b></div>
          <div className="id_date">Date: <b>{certificateData["dateOfSubmission"]}</b></div>
        </div>
        <br />
        <div class="seventh">
          <span className="seventh-1" style={{ "font-family": "monospace" }}>
            <big>CERTIFICATE</big>
          </span>
        </div>
        <br />
        <div class="eighth">
          This is to certify that <b>Mr./Ms.{certificateData["name"]}</b>,
          S/D/o. <b>{certificateData["fatherName"]}</b>, Research Scholar in{" "}
          <b>{certificateData["supervisorDept"]}</b>,{" "}
          {certificateData["supervisorAddr"]}, has submitted his/her Ph.D.
          thesis entitled
          <b>"{certificateData["titleOfThesis"]}"</b>, under the supervision of
          Prof/Dr. <b> {certificateData["supervisorName"]}</b>, Department of{" "}
          <b>{certificateData["supervisorDept"]}</b>,
          {certificateData["supervisorAddr"]}, on{" "}
          <b style={{ "text-decoration": "underline" }}>
            {certificateData["dateOfSubmission"]}
          </b>{" "}
          for the award of Ph.D.Degree in{" "}
          <b>{certificateData["supervisorDept"]}</b> of Kakatiya University,
          Warangal.
        </div>
        <br />
        <br />
        <br />
        <br />
        <div className="ninth">
          <img width="250px" height="90px" src={img2} />
          <br />
          <span className="ninth-1">
            Addl. Controller of Examinations
            <br />
            (Confidential)
          </span>
        </div>
        <br />
        <br />
        <hr style={{ "margin-top": "250px" }} />
        <div class="tenth">
          <button id="print" onClick={printyo}>
            Print
          </button>
        </div>
      </div>
    </>
  );
}

export default CertificateTemplate;
